"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxHeight = void 0;
const core_1 = require("@emotion/core");
exports.maxHeight = '50vh';
exports.default = core_1.css `
  .CodeMirror {
    /* Set height, width, borders, and global font properties here */
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    height: 300px;
  }

  .CodeMirror-scroll {
    max-height: ${exports.maxHeight};
  }

  .CodeMirror-lines {
    padding: 0 0; /* Vertical padding around content */
  }

  .CodeMirror pre {
    padding: 0 0; /* Horizontal padding of content */
    /*
    // air for pills, but screws up other things
    line-height: 1.9;
  */
  }

  .CodeMirror:not(.CodeMirror-focused) .cm-trailingspace,
  .cm-trailingspace-read-only {
    border-bottom: #ff4a00 solid 1px;
    background-position: bottom left;
    background-repeat: repeat-x;
  }

  .CodeMirror span {
    font-family: inherit;
  }
`;
